import { render, staticRenderFns } from "./ThuxTableComponent.vue?vue&type=template&id=1989ceb5&"
import script from "./ThuxTableComponent.vue?vue&type=script&lang=js&"
export * from "./ThuxTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports